import { useSession } from "next-auth/client";
import { useCallback } from "react";
import { useAuthModal } from "./useAuthModal";

export const useCallbackWithAuth = (callback: () => void) => {
  const [session, loading] = useSession();
  const { showAuthModal } = useAuthModal();

  return useCallback(() => {
    if (!loading && session) {
      callback();
    } else {
      showAuthModal();
    }
  }, [callback, loading, session, showAuthModal]);
};
